export default __webpack_public_path__ + "static/ezyVet-8749c50cfcbc1cac73cfb8a3977d4f2f.png";